import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getCMAApiClient } from "@cma/shared/apis/comps/cma/api-factories";
import { buildListCmasQueryKey } from "./useListCmas";

export function useDeleteCma() {
  const api = getCMAApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => api.cMAControllerDelete({ id }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: buildListCmasQueryKey() });
    },
  });
}
